import { useMutableRef } from '@carnica/utils/hooks';
import { useCallback, useEffect, useRef } from 'react';
export var useHorizontalWheelScroll = function useHorizontalWheelScroll(ref, callback) {
  var isActive = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  var callbackRef = useMutableRef(callback);
  var scrollWidthRef = useRef(0);
  var getScrollStep = function getScrollStep() {
    return scrollWidthRef.current / 50;
  };
  var targetLeftRef = useRef(0);
  var scrollLeft = useCallback(function () {
    var container = ref.current;
    if (!container) {
      return;
    }
    var beforeLeft = container.scrollLeft;
    var wantDx = getScrollStep();
    var diff = targetLeftRef.current - container.scrollLeft;
    var dX = wantDx >= Math.abs(diff) ? diff : Math.sign(diff) * wantDx;
    container.scrollBy(dX, 0);
    if (beforeLeft === container.scrollLeft || container.scrollLeft === targetLeftRef.current || dX === diff) {
      return;
    }
    requestAnimationFrame(scrollLeft);
  }, []);
  var listener = useCallback(function (e) {
    var _callbackRef$current;
    (_callbackRef$current = callbackRef.current) === null || _callbackRef$current === void 0 ? void 0 : _callbackRef$current.call(callbackRef, e);
    if (!ref.current) {
      return;
    }
    e.preventDefault();
    scrollWidthRef.current = ref.current.scrollWidth - ref.current.clientWidth;
    targetLeftRef.current = Math.min(scrollWidthRef.current, Math.max(0, ref.current.scrollLeft + e.deltaY));
    requestAnimationFrame(scrollLeft);
  }, []);
  useEffect(function () {
    if (isActive && ref.current) {
      ref.current.addEventListener('wheel', listener);
    }
    return function () {
      var _ref$current;
      (_ref$current = ref.current) === null || _ref$current === void 0 ? void 0 : _ref$current.removeEventListener('wheel', listener);
    };
  }, [isActive]);
};